<template>
    <div class="wrap">
        <div class="container lnb">
            <div class="contents_wrap">
                <div class="contents">
                    <div class="title">회원상세</div>
                    <div class="tab">
                        <div class="tab_wrap">
                            <div class="t_txt" :class="{'active': tabIdx === 1}" @click="changeTab(1)">기본정보</div>
                            <div class="t_txt" :class="{'active': tabIdx === 2}" @click="changeTab(2)">결제내역</div>
                            <div class="t_txt" :class="{'active': tabIdx === 3}" @click="changeTab(3)">구독정보</div>
                            <div class="clear"></div>
                        </div>
                    </div>
                    <div class="tab_content" v-if="tabIdx === 1">
                        <member-write-component :memberType="'normalUpdate'" :memberKey="memberKey"></member-write-component>
                        <div class="text_right pa15">
                            <el-button type="danger" @click="quitMember">강제탈퇴</el-button>
                        </div>
                        <div class="text-center">
                            <el-button type="primary" @click="save">저장</el-button>
                            <el-button @click="$router.back()">목록</el-button>
                        </div>
                    </div>
                    <div class="tab_content" v-else-if="tabIdx === 2">
                        결제내역
                        <member-order-component :memberKey="memberKey"></member-order-component>
                    </div>
                    <div class="tab_content" v-else-if="tabIdx === 3">
                        구독정보
                        <member-subscribe-component :memberKey="memberKey"></member-subscribe-component>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import MemberWriteComponent from "@/components/member/MemberWriteComponent";
    import MemberOrderComponent from "@/components/order/MemberOrderComponent";
    import MemberSubscribeComponent from "@/components/subscribe/MemberSubscribeComponent";
    import EventBus from "@/utils/event-bus";
    export default {
        name: 'MemberDetail',
        components: {
            MemberWriteComponent,
            MemberOrderComponent,
            MemberSubscribeComponent
        },
        mixins: [  ],
        data() {
            return{
                tabIdx: 1,
                memberKey: this.$route.params.mb_no,
            }
        },
        mounted() {
        },
        watch: {

        },
        created() {
        },
        methods: {
            save() {
                EventBus.$emit('writeMember')
            },
            quitMember() {
                EventBus.$emit('quitMember')
            },
            changeTab(num) {
                this.$router.replace(this.$route.path);
                this.tabIdx = num;
            },
        }
    }
</script>
